import { createContext, Dispatch, SetStateAction } from "react";
import { StringRecord } from "~/types/record";
import { MarketPlaceCreationJob, UpdateValuesProps } from "./types";
import { FullAddress } from "~/shared/GoogleMapsInput/types";

export type MultiStepFormProps = Partial<{
    values: Partial<MarketPlaceCreationJob>;
    setValues: Dispatch<SetStateAction<MarketPlaceCreationJob>>;
    currentStep: number;
    setCurrentStep: Dispatch<SetStateAction<number>>;
    setTotalSteps: Dispatch<SetStateAction<number>>;
    handleChange?: (name: string, value: any, options?: { extra?: boolean; updateFn?: UpdateValuesProps }) => void;
    handleBlur: (name: string, value: any, options?: { extra?: boolean }) => void;
    errors: StringRecord;
    handleStatusUpdate: (
        fields: Partial<MarketPlaceCreationJob>,
        value: FullAddress & { region: string }
    ) => Partial<MarketPlaceCreationJob>;
    utmSource: string;
    setUtmSource: Dispatch<SetStateAction<string>>;
    updateStepStorage: (component: string, step: number) => void;
    clearLocalStorageSteps: (components: string[]) => void;
    updateValuesInLocalStorage: () => void;
    confirmationStep: number;
    totalSteps: number;
    openWarningModal: boolean;
    setOpenWarningModal: Dispatch<SetStateAction<boolean>>;
    isAddressAfter: boolean;
    isDateAfter: boolean;
    setIsDateAfter: Dispatch<SetStateAction<boolean>>;
    setIsAddressAfter: Dispatch<SetStateAction<boolean>>;
}>;

const MultiStepFormContext = createContext<MultiStepFormProps>({});

export default MultiStepFormContext;
